<template>
  <app-modal
    v-model="isDialogOpened"
    :ok-text="$t('projects.dialogs.RoomUnderNdaDialog.accessDocument').toString()"
    size="md"
    @ok="signNda"
    @cancel="closeDialog"
  >
    <template #title>
      {{ $t('projects.dialogs.RoomUnderNdaDialog.title') }}
    </template>
    <template #body>
      <p>{{ $t('projects.dialogs.RoomUnderNdaDialog.actionBody') }}</p>
      <p>{{ $t('projects.dialogs.RoomUnderNdaDialog.mailReminderText') }}</p>
    </template>
  </app-modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { mapState } from 'vuex'

import { dialogMixin } from '@/mixins/dialogMixin'
import { NDA_SIGNING_VIEW_ROUTE_NAME } from '@/router/routerData'

export default defineComponent({
  name: 'RoomUnderNdaDialog',
  mixins: [dialogMixin],
  computed: {
    ...mapState('room', ['roomUnderNdaDialog']),
  },
  methods: {
    signNda () {
      this.$router.push({
        name: NDA_SIGNING_VIEW_ROUTE_NAME,
        params: {
          mnemo: this.roomUnderNdaDialog.mnemo,
        },
      })
    },
  },
})
</script>
